// The downloads (decision 066): the platform redirects `/releases/<channel>/<file>`
// to its releases store, so the links are the platform's own: this site
// in a browser, the shell's platform under the host.

import { useHost } from "./host";
import { usePlatformOrigin } from "@/components/ShareAirframe";

export type ReleaseFile = "companion.msi" | "companion.dmg" | "companion.AppImage" | "companion.deb" | "plugin.zip" | "latest.json";

/** The newest pair's file, as a link to open or download. */
export function useReleaseLink(file: ReleaseFile, channel: "latest" | "stable" | "beta" = "latest"): string {
  const host = useHost();
  const origin = usePlatformOrigin();
  const base = host ? origin : "";
  return `${base.replace(/\/+$/, "")}/releases/${channel}/${file}`;
}
